import styled from 'styled-components';

const colors = require('common/lib/colors/colors.less');

export const Button = styled.button`
  align-items: center;
  background-color: ${colors.white};
  border-radius: 4px;
  border: solid 1px ${colors.N40};
  box-sizing: border-box;
  color: ${colors.N800};
  cursor: pointer;
  display: flex;
  font-size: 12px;
  height: 40px;
  justify-content: center;
  transition: 0.05s background-color;
  width: 100%;
  padding: 1px;

  + button {
    margin-left: 8px;
  }

  &:hover {
    background-color: ${colors.N40A};
  }

  &:active {
    background-color: ${colors.N50A};
  }
`;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-detail/Button.js